import React from "react";
import { Outlet } from "react-router-dom";

const Doctors = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Doctors;
